var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bragbar-slider"},[_c('carousel',{attrs:{"autoplay":false,"autoHeight":true,"items":_vm.BragbarSlidercontent.itemPerSlide,"margin":20,"dots":false,"loop":true,"nav":true,"navText":[_vm.prevButton, _vm.nextButton],"mouseDrag":false,"responsive":{
                0:{
                    items:1,
                    nav: true,
                    mouseDrag: true
                },
                750:{
                    items:3,
                    nav: false,
                    mouseDrag: false
                },

            }}},_vm._l((_vm.BragbarSlidercontent.BragbarSlides),function(BragbarSlide,i){return _c('div',{key:i,staticClass:"bragbar-slide px-4"},[_c('p',{staticClass:"bragbar-desc max-w-340px m-auto text-xl leading-8 whitespace-pre-line"},[_vm._v(" "+_vm._s(BragbarSlide.desc)+" ")]),_c('div',{staticClass:"bragbar-slide-logo mt-6"},[_c('img',{staticClass:"bragbar-img w-auto max-h-34px max-w-240px m-auto",attrs:{"src":BragbarSlide.img,"alt":"People"}})])])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }